import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useLoaderData, useParams, useNavigate } from "react-router-dom";
import { Scl90Create } from "./Scl90Create";
import Scl90Questions from "./Scl90Questions";
import { RadioQuestion } from "./Scl90RadioQuestion";
import { calculateScl90Results } from "./Scl90Calc";

import * as APIUSER from "../services/user";

export function Scl90New(props) {
  const scl90 = useLoaderData();
  const navigate = useNavigate();
  const { tratamientoId, pacienteId } = useParams();

  const [missingQuestionsMessage, setMissingQuestionsMessage] = useState("");
  const [isMissingQuestionsModalOpen, setIsMissingQuestionsModalOpen] = useState(false);

  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0]; // Formato 'YYYY-MM-DD'
  };

  const todayDate = getTodayDate();

  const scl90Length = scl90.length;
  const currentSesion = scl90Length + 1;

  const [responses, setResponses] = useState({
    scl90Resp: props.especialistaFullName || "",
    metaFecha: todayDate,
    // Respuestas a las preguntas
    scl90Preg001: "",
    scl90Preg002: "",
    scl90Preg003: "",
    scl90Preg004: "",
    scl90Preg005: "",
    scl90Preg006: "",
    scl90Preg007: "",
    scl90Preg008: "",
    scl90Preg009: "",
    scl90Preg010: "",
    scl90Preg011: "",
    scl90Preg012: "",
    scl90Preg013: "",
    scl90Preg014: "",
    scl90Preg015: "",
    scl90Preg016: "",
    scl90Preg017: "",
    scl90Preg018: "",
    scl90Preg019: "",
    scl90Preg020: "",
    scl90Preg021: "",
    scl90Preg022: "",
    scl90Preg023: "",
    scl90Preg024: "",
    scl90Preg025: "",
    scl90Preg026: "",
    scl90Preg027: "",
    scl90Preg028: "",
    scl90Preg029: "",
    scl90Preg030: "",
    scl90Preg031: "",
    scl90Preg032: "",
    scl90Preg033: "",
    scl90Preg034: "",
    scl90Preg035: "",
    scl90Preg036: "",
    scl90Preg037: "",
    scl90Preg038: "",
    scl90Preg039: "",
    scl90Preg040: "",
    scl90Preg041: "",
    scl90Preg042: "",
    scl90Preg043: "",
    scl90Preg044: "",
    scl90Preg045: "",
    scl90Preg046: "",
    scl90Preg047: "",
    scl90Preg048: "",
    scl90Preg049: "",
    scl90Preg050: "",
    scl90Preg051: "",
    scl90Preg052: "",
    scl90Preg053: "",
    scl90Preg054: "",
    scl90Preg055: "",
    scl90Preg056: "",
    scl90Preg057: "",
    scl90Preg058: "",
    scl90Preg059: "",
    scl90Preg060: "",
    scl90Preg061: "",
    scl90Preg062: "",
    scl90Preg063: "",
    scl90Preg064: "",
    scl90Preg065: "",
    scl90Preg066: "",
    scl90Preg067: "",
    scl90Preg068: "",
    scl90Preg069: "",
    scl90Preg070: "",
    scl90Preg071: "",
    scl90Preg072: "",
    scl90Preg073: "",
    scl90Preg074: "",
    scl90Preg075: "",
    scl90Preg076: "",
    scl90Preg077: "",
    scl90Preg078: "",
    scl90Preg079: "",
    scl90Preg080: "",
    scl90Preg081: "",
    scl90Preg082: "",
    scl90Preg083: "",
    scl90Preg084: "",
    scl90Preg085: "",
    scl90Preg086: "",
    scl90Preg087: "",
    scl90Preg088: "",
    scl90Preg089: "",
    scl90Preg090: "",
  });

  useEffect(() => {
    const loadAutofillData = async () => {
      try {
        const especialista = await APIUSER.getCurrentUser();
        const especialistaFullName = especialista
          ? `${especialista.first_name} ${especialista.last_name}`
          : "";
        setResponses((prev) => ({
          ...prev,
          scl90Resp: especialistaFullName,
        }));
      } catch (error) {
        console.error("Error cargando datos del especialista:", error);
      }
    };
    loadAutofillData();
  }, []);

  const handleResponseChange = useCallback((e) => {
    const { name, value } = e.target;
    setResponses((prev) => {
      if (prev[name] === value) return prev;
      return { ...prev, [name]: value };
    });
  }, []);

  const results = useMemo(() => calculateScl90Results(responses), [responses]);

  const submitScl90 = async (e) => {
    e.preventDefault();
    setMissingQuestionsMessage(""); // Reiniciar mensaje de error
    setIsMissingQuestionsModalOpen(false); // Cerrar modal de error
    setIsCreatingButton(true);

    try {

       // Calcular el total de preguntas
      const totalQuestions = Scl90Questions.length;

      // Contar cuántas preguntas han sido respondidas
      const answeredQuestions = Scl90Questions.filter(
        (question) =>
          responses[question.id] && responses[question.id].trim() !== ""
      ).length;

      // Calcular el porcentaje de respuestas completadas
      const percentage = (answeredQuestions / totalQuestions) * 100;

      if (percentage < 100) {
        setMissingQuestionsMessage(
          "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas."
        );
        setIsMissingQuestionsModalOpen(true);
        setIsCreatingButton(false);
        return; // Evitar el envío del formulario
      }

      // Si la validación pasa, proceder con el envío
      const val = await Scl90Create(
        responses.scl90Resp,
        responses.metaFecha,
        responses.scl90Preg001,
        responses.scl90Preg002,
        responses.scl90Preg003,
        responses.scl90Preg004,
        responses.scl90Preg005,
        responses.scl90Preg006,
        responses.scl90Preg007,
        responses.scl90Preg008,
        responses.scl90Preg009,
        responses.scl90Preg010,
        responses.scl90Preg011,
        responses.scl90Preg012,
        responses.scl90Preg013,
        responses.scl90Preg014,
        responses.scl90Preg015,
        responses.scl90Preg016,
        responses.scl90Preg017,
        responses.scl90Preg018,
        responses.scl90Preg019,
        responses.scl90Preg020,
        responses.scl90Preg021,
        responses.scl90Preg022,
        responses.scl90Preg023,
        responses.scl90Preg024,
        responses.scl90Preg025,
        responses.scl90Preg026,
        responses.scl90Preg027,
        responses.scl90Preg028,
        responses.scl90Preg029,
        responses.scl90Preg030,
        responses.scl90Preg031,
        responses.scl90Preg032,
        responses.scl90Preg033,
        responses.scl90Preg034,
        responses.scl90Preg035,
        responses.scl90Preg036,
        responses.scl90Preg037,
        responses.scl90Preg038,
        responses.scl90Preg039,
        responses.scl90Preg040,
        responses.scl90Preg041,
        responses.scl90Preg042,
        responses.scl90Preg043,
        responses.scl90Preg044,
        responses.scl90Preg045,
        responses.scl90Preg046,
        responses.scl90Preg047,
        responses.scl90Preg048,
        responses.scl90Preg049,
        responses.scl90Preg050,
        responses.scl90Preg051,
        responses.scl90Preg052,
        responses.scl90Preg053,
        responses.scl90Preg054,
        responses.scl90Preg055,
        responses.scl90Preg056,
        responses.scl90Preg057,
        responses.scl90Preg058,
        responses.scl90Preg059,
        responses.scl90Preg060,
        responses.scl90Preg061,
        responses.scl90Preg062,
        responses.scl90Preg063,
        responses.scl90Preg064,
        responses.scl90Preg065,
        responses.scl90Preg066,
        responses.scl90Preg067,
        responses.scl90Preg068,
        responses.scl90Preg069,
        responses.scl90Preg070,
        responses.scl90Preg071,
        responses.scl90Preg072,
        responses.scl90Preg073,
        responses.scl90Preg074,
        responses.scl90Preg075,
        responses.scl90Preg076,
        responses.scl90Preg077,
        responses.scl90Preg078,
        responses.scl90Preg079,
        responses.scl90Preg080,
        responses.scl90Preg081,
        responses.scl90Preg082,
        responses.scl90Preg083,
        responses.scl90Preg084,
        responses.scl90Preg085,
        responses.scl90Preg086,
        responses.scl90Preg087,
        responses.scl90Preg088,
        responses.scl90Preg089,
        responses.scl90Preg090,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../scl-90/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
      setIsCreatingButton(false);
    }
  };

  // const submitScl90 = async (e) => {
  //   e.preventDefault();
  //   setIsCreatingButton(true);
  //   try {
  //     const val = await Scl90Create(
  //       responses.scl90Resp,
  //       responses.metaFecha,
  //       responses.scl90Preg001,
  //       responses.scl90Preg002,
  //       responses.scl90Preg003,
  //       responses.scl90Preg004,
  //       responses.scl90Preg005,
  //       responses.scl90Preg006,
  //       responses.scl90Preg007,
  //       responses.scl90Preg008,
  //       responses.scl90Preg009,
  //       responses.scl90Preg010,
  //       responses.scl90Preg011,
  //       responses.scl90Preg012,
  //       responses.scl90Preg013,
  //       responses.scl90Preg014,
  //       responses.scl90Preg015,
  //       responses.scl90Preg016,
  //       responses.scl90Preg017,
  //       responses.scl90Preg018,
  //       responses.scl90Preg019,
  //       responses.scl90Preg020,
  //       responses.scl90Preg021,
  //       responses.scl90Preg022,
  //       responses.scl90Preg023,
  //       responses.scl90Preg024,
  //       responses.scl90Preg025,
  //       responses.scl90Preg026,
  //       responses.scl90Preg027,
  //       responses.scl90Preg028,
  //       responses.scl90Preg029,
  //       responses.scl90Preg030,
  //       responses.scl90Preg031,
  //       responses.scl90Preg032,
  //       responses.scl90Preg033,
  //       responses.scl90Preg034,
  //       responses.scl90Preg035,
  //       responses.scl90Preg036,
  //       responses.scl90Preg037,
  //       responses.scl90Preg038,
  //       responses.scl90Preg039,
  //       responses.scl90Preg040,
  //       responses.scl90Preg041,
  //       responses.scl90Preg042,
  //       responses.scl90Preg043,
  //       responses.scl90Preg044,
  //       responses.scl90Preg045,
  //       responses.scl90Preg046,
  //       responses.scl90Preg047,
  //       responses.scl90Preg048,
  //       responses.scl90Preg049,
  //       responses.scl90Preg050,
  //       responses.scl90Preg051,
  //       responses.scl90Preg052,
  //       responses.scl90Preg053,
  //       responses.scl90Preg054,
  //       responses.scl90Preg055,
  //       responses.scl90Preg056,
  //       responses.scl90Preg057,
  //       responses.scl90Preg058,
  //       responses.scl90Preg059,
  //       responses.scl90Preg060,
  //       responses.scl90Preg061,
  //       responses.scl90Preg062,
  //       responses.scl90Preg063,
  //       responses.scl90Preg064,
  //       responses.scl90Preg065,
  //       responses.scl90Preg066,
  //       responses.scl90Preg067,
  //       responses.scl90Preg068,
  //       responses.scl90Preg069,
  //       responses.scl90Preg070,
  //       responses.scl90Preg071,
  //       responses.scl90Preg072,
  //       responses.scl90Preg073,
  //       responses.scl90Preg074,
  //       responses.scl90Preg075,
  //       responses.scl90Preg076,
  //       responses.scl90Preg077,
  //       responses.scl90Preg078,
  //       responses.scl90Preg079,
  //       responses.scl90Preg080,
  //       responses.scl90Preg081,
  //       responses.scl90Preg082,
  //       responses.scl90Preg083,
  //       responses.scl90Preg084,
  //       responses.scl90Preg085,
  //       responses.scl90Preg086,
  //       responses.scl90Preg087,
  //       responses.scl90Preg088,
  //       responses.scl90Preg089,
  //       responses.scl90Preg090,
  //       tratamientoId,
  //       pacienteId
  //     ).then(
  //       (val) => {
  //         window.location.replace(`../scl-90/${val.id}`);
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const {
    totalSumSom,
    countSelectedResponsesSom,
    totalDimenSom,
    percSomHomb,
    percSomMuj,
    totalSumObs,
    countSelectedResponsesObs,
    totalDimenObs,
    percObsHomb,
    percObsMuj,
    totalSumSi,
    countSelectedResponsesSi,
    totalDimenSi,
    percSiHomb,
    percSiMuj,
    totalSumDep,
    countSelectedResponsesDep,
    totalDimenDep,
    percDepHomb,
    percDepMuj,
    totalSumAns,
    countSelectedResponsesAns,
    totalDimenAns,
    percAnsHomb,
    percAnsMuj,
    totalSumHos,
    countSelectedResponsesHos,
    totalDimenHos,
    percHosHomb,
    percHosMuj,
    totalSumFob,
    countSelectedResponsesFob,
    totalDimenFob,
    percFobHomb,
    percFobMuj,
    totalSumPar,
    countSelectedResponsesPar,
    totalDimenPar,
    percParHomb,
    percParMuj,
    totalSumPsic,
    countSelectedResponsesPsic,
    totalDimenPsic,
    percPsicHomb,
    percPsicMuj,
    totalSumAdi,
    countSelectedResponsesAdi,
    totalDimenAdi,
    totalSumScl,
    countSelectedResponsesScl,
    resultGsi,
    percGsiHomb,
    percGsiMuj,
    countNonZeroOrEmptyRespPst,
    percPstHomb,
    percPstMuj,
    resultPsdi,
    percPsdiHomb,
    percPsdiMuj,
  } = results;

  return (
    <>
      <div id="content">
        {/* Mostrar modal de error si no se han contestado el 100% de las preguntas */}
        {isMissingQuestionsModalOpen && (
          <div className={`modal ${isMissingQuestionsModalOpen ? "is-active" : ""}`}>
            <div
              className="modal-background"
              onClick={() => setIsMissingQuestionsModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">{missingQuestionsMessage}</section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}
        <form
          id="formNewElement"
          className="newRadioButtons"
          onSubmit={submitScl90}
        >
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="scl90Resp">Responsable</label>
              <div className="control">
                <input
                  className="input"
                  id="scl90Resp"
                  name="scl90Resp"
                  required
                  type="text"
                  value={responses.scl90Resp}
                  onChange={handleResponseChange}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="metaFecha">Fecha visita</label>
              <div className="control">
                <input
                  className="input"
                  id="metaFecha"
                  name="metaFecha"
                  required
                  type="date"
                  value={responses.metaFecha}
                  onChange={handleResponseChange}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario SCL-90-R</h3>
          <p>
            Ayúdanos a optimizar tu tratamiento y observa tu evolución. Completa
            el cuestionario y OBTÉN 15€ A CAMBIO.
          </p>
          <br />
          <p>
            A continuación, hay un listado de problemas que en ocasiones tienen
            las personas. Por favor, léelos cuidadosamente y marca el número que
            mejor describa HASTA QUÉ PUNTO TE HA AFECTADO ESE PROBLEMA DURANTE
            LOS ÚLTIMOS 30 DÍAS. No olvides que debes contestar todas las
            cuestiones planteadas.
          </p>
          <br />
          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--5-col">
                <p>Nada</p>
                <p>Un poco</p>
                <p>Moderadamente</p>
                <p>Bastante</p>
                <p>Mucho</p>
              </div>
            </div>
            {Scl90Questions.map((Scl90Question) => (
              <RadioQuestion
                key={Scl90Question.id}
                id={Scl90Question.id}
                label={Scl90Question.label}
                name={Scl90Question.id}
                value={responses[Scl90Question.id]}
                onChange={handleResponseChange}
              />
            ))}
          </div>
          <div className="form-results form-results-scl90">
            <h3>Resultados de la autoevaluación SCL-90-R</h3>
            <b>Dimension SOM</b>
            <p>Sumatorio SOM {totalSumSom}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesSom()}</p>
            <p>Resultado Dimension SOM: {totalDimenSom}</p>
            <p>Baremo percentil SOM Hombre --- {percSomHomb}</p>
            <p>Baremo percentil SOM Mujer --- {percSomMuj}</p>
            <b>Dimension OBS</b>
            <p>Sumatorio OBS {totalSumObs}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesObs()}</p>
            <p>Resultado Dimension OBS: {totalDimenObs}</p>
            <p>Baremo percentil OBS Hombre --- {percObsHomb}</p>
            <p>Baremo percentil OBS Mujer --- {percObsMuj}</p>
            <b>Dimension INT</b>
            <p>Sumatorio INT {totalSumSi}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesSi()}</p>
            <p>Resultado Dimension SI: {totalDimenSi}</p>
            <p>Baremo percentil INT Hombre --- {percSiHomb}</p>
            <p>Baremo percentil INT Mujer --- {percSiMuj}</p>
            <b>Dimension DEP</b>
            <p>Sumatorio DEP {totalSumDep}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesDep()}</p>
            <p>Resultado Dimension DEP: {totalDimenDep}</p>
            <p>Baremo percentil DEP Hombre --- {percDepHomb}</p>
            <p>Baremo percentil DEP Mujer --- {percDepMuj}</p>
            <b>Dimension ANS</b>
            <p>Sumatorio ANS {totalSumAns}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesAns()}</p>
            <p>Resultado Dimension ANS: {totalDimenAns}</p>
            <p>Baremo percentil ANS Hombre --- {percAnsHomb}</p>
            <p>Baremo percentil ANS Mujer --- {percAnsMuj}</p>
            <b>Dimension HOS</b>
            <p>Sumatorio HOS {totalSumHos}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesHos()}</p>
            <p>Resultado Dimension HOS: {totalDimenHos}</p>
            <p>Baremo percentil HOS Hombre --- {percHosHomb}</p>
            <p>Baremo percentil HOS Mujer --- {percHosMuj}</p>
            <b>Dimension FOB</b>
            <p>Sumatorio FOB {totalSumFob}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesFob()}</p>
            <p>Resultado Dimension FOB: {totalDimenFob}</p>
            <p>Baremo percentil FOB Hombre --- {percFobHomb}</p>
            <p>Baremo percentil FOB Mujer --- {percFobMuj}</p>
            <b>Dimension PAR</b>
            <p>Sumatorio PAR {totalSumPar}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesPar()}</p>
            <p>Resultado Dimension PAR: {totalDimenPar}</p>
            <p>Baremo percentil PAR Hombre --- {percParHomb}</p>
            <p>Baremo percentil PAR Mujer --- {percParMuj}</p>
            <b>Dimension PSI</b>
            <p>Sumatorio PSI {totalSumPsic}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesPsic()}</p>
            <p>Resultado Dimension PSI: {totalDimenPsic}</p>
            <p>Baremo percentil PSI Hombre --- {percPsicHomb}</p>
            <p>Baremo percentil PSI Mujer --- {percPsicMuj}</p>
            <b>Dimension GSI</b>
            <p>Suma de todos los items: {totalSumScl}</p>
            <p>
              Número total de respuestas dadas: {countSelectedResponsesScl()}
            </p>
            <p>Resultado del Indice Global de Severidad --- {resultGsi}</p>
            <p>Baremo percentil GSI Hombre --- {percGsiHomb}</p>
            <p>Baremo percentil GSI Mujer --- {percGsiMuj}</p>
            <b>Total de síntomas positivos PST</b>
            <p>Items con respuesta mayor a 0: {countNonZeroOrEmptyRespPst()}</p>
            <p>Baremo percentil PST Hombre --- {percPstHomb}</p>
            <p>Baremo percentil Pst Mujer --- {percPstMuj}</p>
            <b>Indice positivo de malestar PSDI</b>
            <p>Suma de puntuaciones de todos los items: {totalSumScl}</p>
            <p>Items con respuesta mayor a 0: {countNonZeroOrEmptyRespPst()}</p>
            <p>Resultado de PSDI --- {resultPsdi}</p>
            <p>Baremo percentil PSDI Hombre --- {percPsdiHomb}</p>
            <p>Baremo percentil PSDI Mujer --- {percPsdiMuj}</p>
            <b>Dimension ADI</b>
            <p>Sumatorio ADI {totalSumAdi}</p>
            <p>Respuestas seleccionadas {countSelectedResponsesAdi()}</p>
            <p>Resultado Dimension ADI: {totalDimenAdi}</p>
          </div>
        </form>
      </div>

      <div id="actions">
        <button
          className="button is-link"
          form="formNewElement"
          type="submit"
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      </div>
    </>
  );
}
